import React from 'react';
import { EmailField, TextField, DateField, useUpdate } from 'react-admin';
import { Box, Typography, Divider, Button, withStyles } from '@material-ui/core';
import { red } from '@material-ui/core/colors';

const BlockButton = withStyles((theme) => ({
  root: {
    color: red[500],
  }
}))(Button);

export const UserAside = ({ record, onButtonClick }) => {
  const [update] = useUpdate();

  const now = Date.now();
  let userBlockDate;
  if (record.expire_block) {
    userBlockDate = Date.parse(record.expire_block);
  }
  let isBlocked = record.is_blocked;
  if (userBlockDate) {
    isBlocked = userBlockDate > now;
  }
  let isPremium = record.is_premium;

  const handlePremiumButton = () => {
    const data = { is_premium: !isPremium };
    update('users', record.id, data)
  }

  return record ? (
    <Box ml={4} width={250} minWidth={250}>
      <Box textAlign="center" mb={2}>
        <Button
          size="small"
          onClick={handlePremiumButton}
          color= "secondary"
        >
          Tornar {isPremium ? 'free' : 'premium'}
        </Button>
      </Box>
      <Box textAlign="center" mb={2}>
        {isBlocked
          ? (
            <Button
              size="small"
              onClick={onButtonClick}
              color="secondary"
            >
              Unblock user
            </Button>
          )
          : (
            <BlockButton
              size="small"
              onClick={onButtonClick}
            >
              Block User
            </BlockButton>
          ) 
        }
      </Box>

      <Typography variant="subtitle2">User info</Typography>
      <Divider />

      <Box mt={1}>
        <Typography variant="body2">
          <EmailField source="email" />
        </Typography>
        <Typography variant="body2">
          Phone: <TextField source="phone_number" />
        </Typography>
        <Typography variant="body2">
          Network: <TextField source="social_network" />
        </Typography>
      </Box>

      <Box mt={2}>
        <Typography
          variant="body2"
          color="textSecondary"
        >
          Added on {' '}
          <DateField
            source="created_at"
            options={{ year: 'numeric', month: 'long', day: 'numeric' }}
          />
        </Typography>
      </Box>
    </Box>
  ) : null
}